import {User} from "@/model/User";
import {TransactionItem} from "@/model/TransactionItem";

export class Transaction {
    constructor(public id: string = "",
                public createdDate: string = "",
                public items: TransactionItem[] = [],
                public paymentType = "memberAccount",
                public total: number = 0,
                public state: string = "TransactionState.PENDING",
                public customer?: User,
                public cashier?: User,
                public priceGroup?: string
    ) {}

}
